"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ooxmlToHtml = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _revisionStyle = require("@common/components/remedy/revision-style");
var _proposedRevisions = require("@common/utils/redline/ooxml/proposed-revisions");
var _changeExcerpt = require("@common/utils/redline/text/change-excerpt");
var _tableRowsExcerpt = require("@common/utils/redline/text/table-rows-excerpt");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var parser = new DOMParser();
var OOXML_FRAGMENT_NAMESPACES = ['xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main"', 'xmlns:pkg="http://schemas.microsoft.com/office/2006/xmlPackage"', 'xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"', 'xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml"', 'xmlns:w15="http://schemas.microsoft.com/office/word/2012/wordml"', 'xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006"', 'xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing"', 'xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math"'].join(" ");
var TEXT_BEARING_ELEMENTS = new Set(["w:t", "w:delText", "m:t"]);
var REPLACEMENT_GAP_HTML = '<span class="replacement-gap" aria-hidden="true" style="display:inline-block;width:0.25em"></span>';
var CHANGE_EXCERPT_GAP_HTML = '<span class="change-excerpt-gap" style="display:inline-block;color:var(--foreground-muted);background:none">…</span>';
var changeExcerptMoreHtml = function changeExcerptMoreHtml(leftOutCount) {
  return "<div class=\"change-excerpt-more\" style=\"font-size:var(--text-caption-size);color:var(--foreground-muted)\">".concat(leftOutCount, " more paragraph").concat(leftOutCount === 1 ? "" : "s", " changed</div>");
};
function tableRowsGapLabelOf(leftOutRowCount) {
  if (leftOutRowCount === 1) return "⋯ 1 row";
  return "\u22EF ".concat(leftOutRowCount, " rows");
}
var tableRowsGapHtml = function tableRowsGapHtml(leftOutRowCount, columnCount) {
  return "<tr class=\"table-rows-gap\"><td colspan=\"".concat(columnCount, "\" style=\"border: 1px dashed var(--border-default); padding: 0 6px; font-size: var(--text-caption-size); line-height: var(--text-caption-lh); color: var(--foreground-muted); text-align: center; background: var(--background-subtle);\">").concat(tableRowsGapLabelOf(leftOutRowCount), "</td></tr>");
};

/** Ground tints for a whole row that is a tracked insertion or deletion; the author's colour goes on the row's left edge. */
var INSERTED_ROW_BACKGROUND = "var(--colors-green-50)";
var DELETED_ROW_BACKGROUND = "var(--colors-red-50)";
var revisionSpanStyle = function revisionSpanStyle(author, decoration, authorColorOf) {
  return (0, _revisionStyle.cssTextOf)(_objectSpread(_objectSpread(_objectSpread({}, decoration === "underline" ? _revisionStyle.INSERTION_UNDERLINE : {
    textDecoration: decoration
  }), (0, _revisionStyle.revisionPaintOf)(author, authorColorOf)), {}, {
    cursor: "help"
  }));
};

/** The colour a row's left edge takes for its revision's author: the proposal highlight for the card's own proposal, the author's colour otherwise. */
var revisionEdgeColor = function revisionEdgeColor(author, authorColorOf) {
  return author === _proposedRevisions.PROPOSED_REVISIONS_AUTHOR ? _proposedRevisions.PROPOSED_REVISIONS_HIGHLIGHT : authorColorOf(author);
};

/** The first direct child element with this qualified name, or null. */
var childElementNamed = function childElementNamed(element, nodeName) {
  for (var index = 0; index < element.childNodes.length; index++) {
    var child = element.childNodes[index];
    if (child.nodeType === 1 && child.nodeName === nodeName) return child;
  }
  return null;
};

/**
 * The revision record on a table row, read from `w:trPr/w:ins` or `w:trPr/w:del`.
 *
 * CASES
 *   - w:trPr/w:ins  -> { kind: "inserted", author, date }
 *   - w:trPr/w:del  -> { kind: "deleted", author, date }
 *   - neither       -> null, an ordinary row
 */
var rowRevisionOf = function rowRevisionOf(row) {
  var rowProperties = childElementNamed(row, "w:trPr");
  if (rowProperties === null) return null;
  var insertion = childElementNamed(rowProperties, "w:ins");
  var deletion = childElementNamed(rowProperties, "w:del");
  var record = insertion !== null && insertion !== void 0 ? insertion : deletion;
  if (record === null) return null;
  return {
    kind: insertion !== null ? "inserted" : "deleted",
    author: record.getAttribute("w:author") || "",
    date: record.getAttribute("w:date") || ""
  };
};

/**
 * How many grid columns a cell covers, from `w:tcPr/w:gridSpan`.
 *
 * EXAMPLE
 *   <w:gridSpan w:val="2"/> -> 2, rendered as colspan="2"
 *   no gridSpan             -> 1
 */
var cellColumnSpanOf = function cellColumnSpanOf(cell) {
  var _gridSpan$getAttribut;
  var cellProperties = childElementNamed(cell, "w:tcPr");
  var gridSpan = cellProperties === null ? null : childElementNamed(cellProperties, "w:gridSpan");
  var parsed = gridSpan === null ? NaN : Number.parseInt((_gridSpan$getAttribut = gridSpan.getAttribute("w:val")) !== null && _gridSpan$getAttribut !== void 0 ? _gridSpan$getAttribut : "", 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
};
var hasParseError = function hasParseError(doc) {
  return doc.querySelector("parsererror") !== null;
};
var parseOoxml = function parseOoxml(ooxmlString) {
  var direct = parser.parseFromString(ooxmlString, "application/xml");
  /**
   * WHEN the raw OOXML already parses as XML
   *   RETURNS
   *     The parsed document as-is. No fragment wrapper or synthetic namespaces.
   */
  if (!hasParseError(direct)) return direct;
  var fragment = ooxmlString.replace(/^\s*<\?xml[^>]*\?>/, "");
  return parser.parseFromString("<ooxmlfragment ".concat(OOXML_FRAGMENT_NAMESPACES, ">").concat(fragment, "</ooxmlfragment>"), "application/xml");
};
var fallbackText = function fallbackText(ooxmlString) {
  var runs = ooxmlString.match(/<w:t[^>]*>([^<]*)<\/w:t>/g);
  /**
   * FALLBACK
   *   CASES
   *     - <w:t> runs found     -> join their literal text
   *     - no <w:t> runs found  -> use an empty string, not an exception
   *
   * WHY
   *   This is the last text-only recovery path when XML parsing failed.
   */
  return (runs ? runs.map(function (m) {
    return m.replace(/<w:t[^>]*>([^<]*)<\/w:t>/, "$1");
  }).join("") : "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
};

/**
 * The five characters that would otherwise end an attribute or open a tag.
 *
 * WHY
 *   `title` carries `w:author` and `w:date` from the document under review, and a
 *   counterparty writes those. A `&quot;` in an author name decodes to a real quote
 *   at the XML layer and then closes the attribute here, so the rest of the name is
 *   read as markup: `html-react-parser` drops the event handlers React refuses but
 *   keeps the elements, and an injected `<img src=...>` fetches from wherever it
 *   names every time the redline is previewed.
 */
var escapeForHtmlAttribute = function escapeForHtmlAttribute(value) {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
};

/**
 * Renders the document part of an OOXML string as HTML.
 *
 * `markCommentRanges` wraps each text run that sits inside a comment's range
 * (`w:commentRangeStart` … `w:commentRangeEnd`) in a span naming the comment, so a
 * reader can colour the commented words. The span wraps the run alone, never the
 * insertion or deletion wrapper around it, because a comment range may start or end
 * inside a revision. Off by default: a redline preview shows the document's comment
 * ranges as nothing, as it always has.
 */
var ooxmlToHtml = exports.ooxmlToHtml = function ooxmlToHtml(ooxmlString, getHtmlTitleProp) {
  var markCommentRanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var drawMoveMarks = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var drawReplacementGaps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var changeExcerpt = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var authorColorOf = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : _RedlineAuthorColorsContext.colorOfAuthorOutsideAnyProvider;
  var tableRowsExcerpt = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
  var xmlDoc = parseOoxml(ooxmlString);
  /**
   * WHEN the wrapped parse still has a parser error
   *   CONSEQUENCE
   *     Return best-effort text from fallbackText(ooxmlString).
   */
  if (hasParseError(xmlDoc)) return fallbackText(ooxmlString);
  if (tableRowsExcerpt !== null) _tableRowsExcerpt.TableRowsExcerpt.cut(xmlDoc, tableRowsExcerpt);
  if (changeExcerpt !== null) _changeExcerpt.ChangeExcerpt.cut(xmlDoc, changeExcerpt);
  var htmlString = "";
  /** The ids of the comments whose range the walk is inside right now, in the order they opened. */
  var openCommentIds = [];
  var struckWordsClosedJustBefore = false;
  var _transformNode = function transformNode(node) {
    var html = "";
    if (node.nodeType === 1) {
      switch (node.nodeName) {
        /**
         * CASES
         *   - w:ins  -> open the HTML wrapper for inserted content before visiting children
         */
        case "w:ins":
          {
            var _author = node.getAttribute("w:author") || "";
            var date = node.getAttribute("w:date") || "";
            /**
             * CASES
             *   - getHtmlTitleProp exists  -> use the caller-supplied title
             *   - otherwise                -> use author and date from OOXML
             */
            var title = getHtmlTitleProp ? getHtmlTitleProp(node) : "Author: ".concat(_author, ", Date: ").concat(date);
            if (drawReplacementGaps && struckWordsClosedJustBefore) html += REPLACEMENT_GAP_HTML;
            struckWordsClosedJustBefore = false;
            html += "<span style=\"".concat(revisionSpanStyle(_author, "underline", authorColorOf), "\" title=\"").concat(escapeForHtmlAttribute(title), "\">");
            break;
          }
        /**
         * CASES
         *   - w:del  -> open the HTML wrapper for deleted content before visiting children
         */
        case "w:del":
          {
            var _author2 = node.getAttribute("w:author") || "";
            var _date = node.getAttribute("w:date") || "";
            /**
             * CASES
             *   - getHtmlTitleProp exists  -> use the caller-supplied title
             *   - otherwise                -> use author and date from OOXML
             */
            var _title = getHtmlTitleProp ? getHtmlTitleProp(node) : "Author: ".concat(_author2, ", Date: ").concat(_date);
            html += "<span style=\"".concat(revisionSpanStyle(_author2, "line-through", authorColorOf), "\" title=\"").concat(escapeForHtmlAttribute(_title), "\">");
            break;
          }
        /**
         * CASES
         *   - w:moveFrom, drawMoveMarks on  -> drawn as the deletion it is: the words Word moved away from here, struck in the mover's colour
         *   - w:moveTo,   drawMoveMarks on  -> drawn as the insertion it is: the words at their new place, underlined in the mover's colour
         *   - drawMoveMarks off             -> plain text, as production has always drawn a move
         *
         * WHY behind a flag
         *   This component draws production's cards too; the proposal engine's previews
         *   turn the marks on, so a counterparty's move and our undoing of it both show.
         */
        case "w:moveFrom":
        case "w:moveTo":
          {
            if (!drawMoveMarks) break;
            var _author3 = node.getAttribute("w:author") || "";
            var _date2 = node.getAttribute("w:date") || "";
            var _title2 = getHtmlTitleProp ? getHtmlTitleProp(node) : "Author: ".concat(_author3, ", Date: ").concat(_date2);
            var decoration = node.nodeName === "w:moveFrom" ? "line-through" : "underline";
            if (node.nodeName === "w:moveTo" && drawReplacementGaps && struckWordsClosedJustBefore) html += REPLACEMENT_GAP_HTML;
            struckWordsClosedJustBefore = false;
            html += "<span style=\"".concat(revisionSpanStyle(_author3, decoration, authorColorOf), "\" title=\"").concat(escapeForHtmlAttribute(_title2), "\">");
            break;
          }
        /**
         * CASES
         *   - w:p  -> open a block container so paragraph boundaries survive in HTML
         */
        case "w:p":
          {
            struckWordsClosedJustBefore = false;
            html += "<div>";
            break;
          }
        /**
         * CASES
         *   - w:tbl  -> an HTML table; the grid and its properties render nothing, only rows and cells do
         */
        case "w:tbl":
          {
            html += '<table style="border-collapse: collapse; width: 100%; margin: 4px 0;">';
            break;
          }
        /**
         * CASES
         *   - w:tr, ordinary row      -> a plain <tr>
         *   - w:tr, tracked insertion -> tinted row with the author's colour on its left edge, titled like a w:ins
         *   - w:tr, tracked deletion  -> tinted row, struck, titled like a w:del
         *
         * WHY
         *   Word marks a whole-row change on the row itself as well as on every run inside it;
         *   the runs carry their own wrappers, the row tint shows the change is the row.
         */
        case "w:tr":
          {
            var rowRevision = rowRevisionOf(node);
            if (rowRevision === null) {
              html += "<tr>";
              break;
            }
            var _title3 = getHtmlTitleProp ? getHtmlTitleProp(node) : "Author: ".concat(rowRevision.author, ", Date: ").concat(rowRevision.date);
            var background = rowRevision.kind === "inserted" ? INSERTED_ROW_BACKGROUND : DELETED_ROW_BACKGROUND;
            var strike = rowRevision.kind === "deleted" ? " text-decoration: line-through;" : "";
            html += "<tr title=\"".concat(escapeForHtmlAttribute(_title3), "\" style=\"background: ").concat(background, "; border-left: 3px solid ").concat(revisionEdgeColor(rowRevision.author, authorColorOf), ";").concat(strike, "\">");
            break;
          }
        /**
         * CASES
         *   - w:tc  -> a bordered cell, spanning the grid columns its gridSpan names
         */
        case "w:tc":
          {
            var columnSpan = cellColumnSpanOf(node);
            var colspan = columnSpan > 1 ? " colspan=\"".concat(columnSpan, "\"") : "";
            html += "<td".concat(colspan, " style=\"border: 1px solid var(--border-default); padding: 2px 6px; vertical-align: top;\">");
            break;
          }
        /**
         * CASES
         *   - w:br  -> render one HTML <br/>
         *   - w:cr  -> render the same HTML <br/>
         */
        /**
         * CASES
         *   - w:commentRangeStart  -> the runs that follow are inside this comment, until its end mark
         *   - w:commentRangeEnd    -> the comment's range is over
         * Neither renders anything itself; the runs inside carry the mark (`markCommentRanges`).
         */
        case "w:commentRangeStart":
          {
            openCommentIds.push(node.getAttribute("w:id") || "");
            return "";
          }
        case "w:commentRangeEnd":
          {
            var endedCommentId = node.getAttribute("w:id") || "";
            var openedAt = openCommentIds.indexOf(endedCommentId);
            if (openedAt >= 0) openCommentIds.splice(openedAt, 1);
            return "";
          }
        case "w:br":
        case "w:cr":
          {
            struckWordsClosedJustBefore = false;
            html += "<br/>";
            break;
          }
        /**
         * WHY
         *   HTML collapses literal tab characters in normal flow.
         *
         * CASES
         *   - w:tab  -> emit a fixed-width inline spacer
         */
        case "w:tab":
          {
            struckWordsClosedJustBefore = false;
            html += '<span style="display:inline-block;width:2em"></span>';
            break;
          }
        /**
         * CASES
         *   - w:instrText  -> return an empty string and skip this subtree
         */
        case "w:instrText":
          {
            return "";
          }
        case _changeExcerpt.CHANGE_EXCERPT_GAP:
          {
            struckWordsClosedJustBefore = false;
            return CHANGE_EXCERPT_GAP_HTML;
          }
        case _changeExcerpt.CHANGE_EXCERPT_MORE:
          {
            return changeExcerptMoreHtml(Number(node.getAttribute(_changeExcerpt.CHANGE_EXCERPT_MORE_COUNT)));
          }
        case _tableRowsExcerpt.TABLE_ROWS_EXCERPT_GAP:
          {
            return tableRowsGapHtml(Number(node.getAttribute(_tableRowsExcerpt.TABLE_ROWS_EXCERPT_GAP_COUNT)), Number(node.getAttribute(_tableRowsExcerpt.TABLE_ROWS_EXCERPT_GAP_COLUMNS)));
          }
        case _changeExcerpt.CHANGE_EXCERPT_PARAGRAPH_MARK:
          {
            var _author4 = node.getAttribute("w:author") || "";
            var _date3 = node.getAttribute("w:date") || "";
            var _title4 = getHtmlTitleProp ? getHtmlTitleProp(node) : "Author: ".concat(_author4, ", Date: ").concat(_date3);
            var _decoration = node.getAttribute(_changeExcerpt.CHANGE_EXCERPT_PARAGRAPH_MARK_KIND) === "inserted" ? "underline" : "line-through";
            struckWordsClosedJustBefore = false;
            return "<span style=\"".concat(revisionSpanStyle(_author4, _decoration, authorColorOf), "\" title=\"").concat(escapeForHtmlAttribute(_title4), "\">\xB6</span>");
          }
        /**
         * The property elements of a paragraph, run, row, cell and table.
         * They describe how their owner is formatted and render nothing
         * themselves, so the subtree is skipped whole.
         *
         * WHY skipping rather than falling through
         *   Word records a tracked row change twice: once on the row's own
         *   `w:trPr/w:ins` and once on every run inside it. Walking into the
         *   properties reached that `w:ins` a second time and emitted its
         *   wrapper with no text in it, so a tracked-inserted row rendered a
         *   `<span>` between the `<tr>` and its first `<td>` — a position the
         *   HTML content model does not allow a span, and one the browser
         *   never corrects here because html-react-parser builds the React
         *   elements directly instead of reparsing the markup.
         *
         * The row tint still works: `rowRevisionOf` reads `w:trPr` through
         * `childElementNamed`, a direct lookup that does not use this walk.
         */
        case "w:pPr":
        case "w:rPr":
        case "w:trPr":
        case "w:tcPr":
        case "w:tblPr":
        case "w:tblGrid":
          {
            return "";
          }
        default:
          break;
      }
      var _loop = function _loop() {
        var childNode = node.childNodes[i];
        var childNodeIsPackagePart = childNode.nodeName === "pkg:part";
        var childNodeShouldBeSkipped = function childNodeShouldBeSkipped() {
          if (!childNodeIsPackagePart) return false;
          var childPartName = childNode.getAttribute("pkg:name");
          return childPartName !== "/word/document.xml";
        };
        /**
         * WHEN a pkg:part is not /word/document.xml
         *   CONSEQUENCE
         *     Skip that package part instead of rendering headers, relationships, or other XML parts.
         */
        if (childNodeShouldBeSkipped()) {
          return 1; // continue
        }
        html += _transformNode(childNode);
      };
      for (var i = 0; i < node.childNodes.length; i++) {
        if (_loop()) continue;
      }
      switch (node.nodeName) {
        /**
         * CASES
         *   - w:ins  -> close the insertion wrapper after children are rendered
         */
        case "w:ins":
          {
            html += "</span>";
            break;
          }
        /**
         * CASES
         *   - w:del  -> close the deletion wrapper after children are rendered
         */
        case "w:del":
          {
            html += "</span>";
            struckWordsClosedJustBefore = true;
            break;
          }
        /**
         * CASES
         *   - w:moveFrom / w:moveTo, drawMoveMarks on -> close the wrapper opened above
         *   - drawMoveMarks off                       -> nothing was opened
         */
        case "w:moveFrom":
        case "w:moveTo":
          {
            if (drawMoveMarks) html += "</span>";
            if (drawMoveMarks && node.nodeName === "w:moveFrom") struckWordsClosedJustBefore = true;
            break;
          }
        /**
         * CASES
         *   - w:p  -> close the paragraph container after children are rendered
         */
        case "w:p":
          {
            html += "</div>";
            break;
          }
        case "w:tbl":
          {
            html += "</table>";
            break;
          }
        case "w:tr":
          {
            html += "</tr>";
            break;
          }
        case "w:tc":
          {
            html += "</td>";
            break;
          }
        /**
         * WHEN the node is text and its parent is in TEXT_BEARING_ELEMENTS
         *   CONSEQUENCE
         *     Escape and emit the text content.
         *
         * WHY
         *   Ignore text nodes under structural OOXML elements that do not carry document text.
         */
        default:
          break;
      }
    } else {
      var nodeIsTextNode = node.nodeType === 3;
      var nodeCarriesDocumentText = function nodeCarriesDocumentText() {
        var _node$parentNode$node, _node$parentNode;
        if (!nodeIsTextNode) return false;
        var parentNodeName = (_node$parentNode$node = (_node$parentNode = node.parentNode) === null || _node$parentNode === void 0 ? void 0 : _node$parentNode.nodeName) !== null && _node$parentNode$node !== void 0 ? _node$parentNode$node : "";
        return TEXT_BEARING_ELEMENTS.has(parentNodeName);
      };
      if (nodeIsTextNode && nodeCarriesDocumentText()) {
        struckWordsClosedJustBefore = false;
        var nodeText = node.nodeValue || "";
        var escapedText = nodeText.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        /** A run inside one or more comment ranges names them all, space-separated, so a `~=` selector finds any one of them. */
        html += markCommentRanges && openCommentIds.length > 0 ? "<span class=\"ooxml-comment-range\" data-comment-id=\"".concat(escapeForHtmlAttribute(openCommentIds.join(" ")), "\">").concat(escapedText, "</span>") : escapedText;
      }
    }
    return html;
  };
  htmlString = xmlDoc.childNodes.length > 0 ? Array.from(xmlDoc.childNodes).map(_transformNode).join("") : _transformNode(xmlDoc.documentElement);
  return htmlString;
};
var DRAWN_OOXML_CACHE_PACKAGE_LIMIT = 300;
var drawnOoxmlByPackage = new Map();
var identityOfFunction = new WeakMap();
var nextFunctionIdentity = 1;
function functionIdentityOf(drawingFunction) {
  if (drawingFunction === undefined) return 0;
  var knownIdentity = identityOfFunction.get(drawingFunction);
  if (knownIdentity !== undefined) return knownIdentity;
  var identity = nextFunctionIdentity;
  nextFunctionIdentity += 1;
  identityOfFunction.set(drawingFunction, identity);
  return identity;
}
function drawnOoxmlOf(ooxml, drawingOptionsKey, draw) {
  var _drawnOoxmlByPackage$;
  var drawingsOfPackage = (_drawnOoxmlByPackage$ = drawnOoxmlByPackage.get(ooxml)) !== null && _drawnOoxmlByPackage$ !== void 0 ? _drawnOoxmlByPackage$ : new Map();
  drawnOoxmlByPackage.delete(ooxml);
  drawnOoxmlByPackage.set(ooxml, drawingsOfPackage);
  var cachedDrawing = drawingsOfPackage.get(drawingOptionsKey);
  if (cachedDrawing !== undefined) return cachedDrawing;
  var drawing = draw();
  drawingsOfPackage.set(drawingOptionsKey, drawing);
  var leastRecentlyDrawnPackage = drawnOoxmlByPackage.keys().next().value;
  if (drawnOoxmlByPackage.size > DRAWN_OOXML_CACHE_PACKAGE_LIMIT && leastRecentlyDrawnPackage !== undefined) drawnOoxmlByPackage.delete(leastRecentlyDrawnPackage);
  return drawing;
}
function parsedHtmlOf(htmlContent) {
  try {
    return (0, _htmlReactParser.default)(htmlContent);
  } catch (_unused) {
    return htmlContent;
  }
}
var OoxmlComponent = function OoxmlComponent(_ref) {
  var ooxml = _ref.ooxml,
    style = _ref.style,
    getHtmlTitleProp = _ref.getHtmlTitleProp,
    _ref$markCommentRange = _ref.markCommentRanges,
    markCommentRanges = _ref$markCommentRange === void 0 ? false : _ref$markCommentRange,
    _ref$drawMoveMarks = _ref.drawMoveMarks,
    drawMoveMarks = _ref$drawMoveMarks === void 0 ? false : _ref$drawMoveMarks,
    _ref$drawReplacementG = _ref.drawReplacementGaps,
    drawReplacementGaps = _ref$drawReplacementG === void 0 ? false : _ref$drawReplacementG,
    _ref$changeExcerpt = _ref.changeExcerpt,
    changeExcerpt = _ref$changeExcerpt === void 0 ? null : _ref$changeExcerpt,
    _ref$tableRowsExcerpt = _ref.tableRowsExcerpt,
    tableRowsExcerpt = _ref$tableRowsExcerpt === void 0 ? null : _ref$tableRowsExcerpt,
    authorColorOf = _ref.authorColorOf;
  var colorOfAuthor = (0, _RedlineAuthorColorsContext.useRedlineAuthorColor)();
  var authorColorShown = authorColorOf !== null && authorColorOf !== void 0 ? authorColorOf : colorOfAuthor;
  var drawingOptionsKey = JSON.stringify([functionIdentityOf(getHtmlTitleProp), functionIdentityOf(authorColorShown), markCommentRanges, drawMoveMarks, drawReplacementGaps, changeExcerpt, tableRowsExcerpt]);
  var parsed = drawnOoxmlOf(ooxml, drawingOptionsKey, function () {
    return parsedHtmlOf(ooxmlToHtml(ooxml, getHtmlTitleProp, markCommentRanges, drawMoveMarks, drawReplacementGaps, changeExcerpt, authorColorShown, tableRowsExcerpt));
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "break-words text-base font-normal not-italic",
    style: style,
    "data-sentry-component": "OoxmlComponent",
    "data-sentry-source-file": "OoxmlContent.tsx",
    children: parsed
  });
};
var _default = exports.default = OoxmlComponent;